<script setup lang="ts">
import type { EColors } from '@/types/constants/ColorValues'

type Props = {
    label: string
    type?: EColors
}
defineProps<Props>()
</script>

<template>
    <b-step-item :label="label" :type="`is-${type ?? 'primary'}`" v-bind="$attrs">
        <slot />
    </b-step-item>
</template>
